module.exports = __webpack_public_path__ + "fonts/fontello.6ab4dc97.eot";